import isEmail from 'validator/lib/isEmail'

const checkEmailValidationsWithAt = email => {
  if (!email) return 'newsletter.form.emailEmptyError'
  if (!email.includes('@')) return 'newsletter.form.emailAtError'

  const hasValueAfterAt = email.split('@')

  if (!hasValueAfterAt[1]) return 'newsletter.form.emailAfterAtError'

  return false
}

export function isInvalidEmail(email) {
  const checkAtEmail = checkEmailValidationsWithAt(email)

  if (checkAtEmail) return checkAtEmail

  return isEmail(email) ? false : 'newsletter.form.emailHelperInvalid'
  
}
